import React, { useState, Fragment, useEffect } from 'react';
import DataTable from 'react-data-table-component';
import { toast } from 'react-toastify';
import API from '../../services/API';
import { Modal, ModalHeader, ModalBody, ModalFooter, Button, Collapse, Alert, Input, Table } from 'reactstrap';
import Select from 'react-select';
import { useNavigate } from 'react-router-dom'; // Import useNavigate
import { Tag, Dropdown, Menu, Tooltip } from 'antd';
import { Eye, Edit3, Trash2, Badge, UserPlus, Settings, MoreHorizontal } from 'lucide-react';

const ClassesPage = () => {
    const [classes, setClasses] = useState([]);
    const [teachers, setTeachers] = useState([]); // List of all teachers
    const [selectedClass, setSelectedClass] = useState(null);
    const [isEditModalOpen, setIsEditModalOpen] = useState(false);
    const [isAddModalOpen, setIsAddModalOpen] = useState(false);
    const [updatedClassName, setUpdatedClassName] = useState('');
    const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
    const [selectedTeachers, setSelectedTeachers] = useState([]); // Selected teachers for the class
    const [newClassName, setNewClassName] = useState('');
    const [selectedForm, setSelectedForm] = useState(null); // Selected form for the new class
    const [selectedSession, setSelectedSession] = useState(null);
    const [editSession, setEditSession] = useState(null);
    const [newTingkatan, setNewTingkatan] = useState('');
    const [newClassMoeis, setNewClassMoeis] = useState('');
    const [editTingkatan, setEditTingkatan] = useState('');
    const [editClassMoeis, setEditClassMoeis] = useState('');
    const [formFilter, setFormFilter] = useState(null);
    const [uniqueForms, setUniqueForms] = useState([]);
    const [incompleteClasses, setIncompleteClasses] = useState([]);
    const [currentIncompleteIndex, setCurrentIncompleteIndex] = useState(0);
    const [infoOpen, setInfoOpen] = useState(false);

    const [isBulkModalOpen, setIsBulkModalOpen] = useState(false);
    const [bulkData, setBulkData] = useState([]);
    const [bulkResults, setBulkResults] = useState(null);
    const [isProcessingBulk, setIsProcessingBulk] = useState(false);

    const [rawPasteData, setRawPasteData] = useState('');
    const [rawCheckResults, setRawCheckResults] = useState({});
    const [isCheckingNames, setIsCheckingNames] = useState(false);

    const [isGuruKelasModalOpen, setIsGuruKelasModalOpen] = useState(false);
    const [guruKelasClass, setGuruKelasClass] = useState(null); // The class we're editing
    const [guruKelasOption, setGuruKelasOption] = useState(null); // The teacher being set
    const [guruKelasLoading, setGuruKelasLoading] = useState(false);
    const [allTeacherEnabled, setAllTeacherEnabled] = useState(0);

    // Rotate every 3 seconds
    useEffect(() => {
        if (incompleteClasses.length > 0) {
            const interval = setInterval(() => {
                setCurrentIncompleteIndex(prev =>
                    (prev + 1) % incompleteClasses.length
                );
            }, 3000); // change every 3s
            return () => clearInterval(interval);
        }
    }, [incompleteClasses]);
    const sessionOptions = [
        { value: 0, label: "Morning" },
        { value: 1, label: "Afternoon" },
    ];

    const navigate = useNavigate();
    // --- BULK MOVE FUNCTIONS ---

    const handleRawPasteChange = (e) => {
        const text = e.target.value;
        setRawPasteData(text);

        const rows = text.split('\n').filter(row => row.trim() !== '');
        const parsed = rows.map(row => {
            // Splitting by Tab first (common in Excel), then by Comma
            let cols = row.includes('\t') ? row.split('\t') : row.split(',');

            // Clean up the data
            const rawMoeisName = (cols[0] || '').trim();
            const inputClassName = (cols[1] || '').trim();

            const matchedClass = classes.find(
                c => c.class_name.toLowerCase() === inputClassName.toLowerCase()
            );

            return {
                moeis_name: rawMoeisName,
                new_class_name: inputClassName,
                class_id: matchedClass ? matchedClass.class_id : null
            };
        }).filter(item => item.moeis_name);

        setBulkData(parsed);
    };
    // Real-time validation for student existence (Debounced)
    useEffect(() => {
        // 1. Extract only valid names to check
        const namesToCheck = bulkData
            .map(d => d.moeis_name)
            .filter(n => n && n.trim().length > 0);

        // 2. Clear results if input is empty
        if (namesToCheck.length === 0) {
            setRawCheckResults({});
            return;
        }

        // 3. Debounce the API call
        const delayDebounceFn = setTimeout(async () => {
            setIsCheckingNames(true);
            try {
                const token = localStorage.getItem("token");
                const response = await API.post(
                    "/student/bulkCheckByMoeisName",
                    { names: namesToCheck },
                    { headers: { 'token': token } }
                );

                if (response.data.response_code === 1000) {
                    const foundMap = {};
                    response.data.data.found.forEach(student => {
                        foundMap[student.moeis_name.trim().toUpperCase()] = student;
                    });
                    const notFoundSet = new Set(
                        (response.data.data.not_found || []).map(name => name.trim().toUpperCase())
                    );
                    setRawCheckResults({ foundMap, notFoundSet });


                } else {
                    console.error("API error:", response.data.message);
                }
            } catch (err) {
                console.error("Network error during check:", err);
            } finally {
                setIsCheckingNames(false);
            }
        }, 1000); // Wait 1 second after last edit

        return () => clearTimeout(delayDebounceFn);
    }, [bulkData]); // Listen for any changes in the parsed data
    const handleExecuteBulkMove = () => {
        setIsProcessingBulk(true);
        const headers = { 'token': localStorage.getItem('token') };

        API.post('/bulkMoveStudentsByMoeis', { students: bulkData }, { headers })
            .then(res => {
                if (res.data.response_code === 1000) {
                    setBulkResults(res.data.data);
                    toast.success("Bulk promotion completed.");
                    fetchClasses();
                } else {
                    toast.error(res.data.message);
                }
            })
            .catch(() => toast.error("Error connecting to server"))
            .finally(() => setIsProcessingBulk(false));
    };

    const closeBulkModal = () => {
        setIsBulkModalOpen(false);
        setBulkData([]);
        setBulkResults(null);
    };
    const forms = [
        {
            label: 'Others(Teacher/Staff etc)',
            value: '0',  // or use '7' if your backend expects a number
        },
        {
            label: 'Pra-sekolah',
            value: '9',  // or use '7' if your backend expects a number
        },
        {
            label: 'Khas',
            value: '7',  // or use '7' if your backend expects a number
        },
        {
            label: 'Peralihan',
            value: '8',  // or use '7' if your backend expects a number
        },
        ...Array.from({ length: 6 }, (_, index) => ({
            label: `Form/Standard/Tadika ${index + 1}`,
            value: `${index + 1}`,
        })),

    ];
    // Filter classes by form
    const filteredClasses = formFilter
        ? classes.filter(
            (c) => String(c.tingkatan_moeis).toUpperCase().trim() === formFilter
        )
        : classes;
    const [columns] = useState([
        {
            name: "CLASS IDENTITY",
            grow: 1.2,
            sortable: true,
            selector: row => row.class_name,
            cell: (row) => (
                <div className="py-3">
                    <div style={{
                        fontWeight: '700',
                        color: '#1a1a1a',
                        fontSize: '15px',
                        letterSpacing: '-0.01em'
                    }}>
                        {row.class_name}
                    </div>

                    {row.class_moeis_format && (
                        <div style={{ fontSize: '11px', color: '#dc2626', fontWeight: '600', marginTop: '2px' }}>
                            {row.class_moeis_format}
                        </div>
                    )}
                    <div style={{
                        marginTop: '8px',
                        display: 'inline-flex',
                        alignItems: 'center',
                        gap: '6px',
                        padding: '3px 10px',
                        borderRadius: '4px',
                        fontSize: '10px',
                        fontWeight: '700',
                        background: row.session === 0 ? '#fef2f2' : '#fff1f2',
                        color: row.session === 0 ? '#991b1b' : '#be123c',
                        border: `1px solid ${row.session === 0 ? '#fee2e2' : '#fecdd3'}`
                    }}>
                        <span style={{ width: '6px', height: '6px', borderRadius: '50%', background: '#ef4444' }} />
                        {row.session === 0 ? 'MORNING SESSION' : 'AFTERNOON SESSION'}
                    </div>
                </div>
            )
        },
        {
            name: "SUBJECT TEACHERS",
            grow: 3,
            cell: (row) => (
                <div style={{ display: 'flex', flexWrap: 'wrap', gap: '6px', padding: '10px 0' }}>
                    {row.all_teacher_enabled === 1 ? (
                        <div
                            style={{
                                display: 'inline-flex',
                                alignItems: 'center',
                                padding: '6px 14px',
                                background: '#ecfdf5',
                                border: '1px solid #a7f3d0',
                                borderRadius: '999px',
                                fontSize: '12px',
                                fontWeight: '800',
                                color: '#047857'
                            }}
                        >
                            ALL TEACHERS
                        </div>
                    ) : (
                        row.teachers.length > 0 ? (
                            row.teachers.map((teacher, index) => (
                                <div
                                    key={teacher.teacher_uuid || index}
                                    style={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        padding: '5px 12px',
                                        background: '#ffffff',
                                        border: '1px solid #e5e7eb',
                                        borderRadius: '6px',
                                        boxShadow: '0 1px 2px rgba(0,0,0,0.04)'
                                    }}
                                >
                                    <span style={{
                                        fontSize: '13px',
                                        fontWeight: '500',
                                        color: '#374151'
                                    }}>
                                        {teacher.teacher_name}
                                    </span>
                                </div>
                            ))
                        ) : (
                            <span style={{ color: '#9ca3af', fontSize: '12px', fontStyle: 'italic' }}>
                                No teachers assigned
                            </span>
                        )
                    )}

                </div>
            ),
        },
        {
            name: "GURU KELAS",
            grow: 1.5,
            cell: row => (
                <div style={{
                    background: row.class_teacher_name ? '#fff1f2' : '#f9fafb',
                    border: `1px solid ${row.class_teacher_name ? '#fecdd3' : '#e5e7eb'}`,
                    borderRadius: '8px',
                    padding: '10px',
                    width: '100%',
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    textAlign: 'center'
                }}>
                    {row.class_teacher_name ? (
                        <>
                            <div style={{ fontSize: '10px', fontWeight: '800', color: '#be123c', marginBottom: '2px' }}>GURU KELAS</div>
                            <div style={{ fontSize: '13px', fontWeight: '700', color: '#111827' }}>{row.class_teacher_name}</div>
                            <div style={{ display: 'flex', gap: '10px', marginTop: '8px' }}>
                                <button onClick={() => openGuruKelasModal(row)} style={{ background: 'none', border: 'none', color: '#dc2626', fontSize: '11px', fontWeight: '700', cursor: 'pointer', padding: 0 }}>Change</button>
                                <button onClick={() => handleUnsetGuruKelas(row)} style={{ background: 'none', border: 'none', color: '#6b7280', fontSize: '11px', fontWeight: '500', cursor: 'pointer', padding: 0 }}>Remove</button>
                            </div>
                        </>
                    ) : (
                        <button
                            onClick={() => openGuruKelasModal(row)}
                            style={{ background: 'none', border: 'none', color: '#dc2626', fontSize: '12px', fontWeight: '700', cursor: 'pointer' }}
                        >
                            + Set Guru Kelas
                        </button>
                    )}
                </div>
            )
        },
        {
            name: "ACTIONS",
            width: "140px",
            right: true,
            cell: (row) => (
                <div style={{ display: 'flex', gap: '8px' }}>
                    <button
                        onClick={() => navigate(`/class-details/${row.class_id}`)}
                        style={{ padding: '8px', background: '#fff', border: '1px solid #e5e7eb', borderRadius: '6px', cursor: 'pointer', color: '#4b5563' }}
                    >
                        <Eye size={16} />
                    </button>
                    <button
                        onClick={() => openEditModal(row)}
                        style={{ padding: '8px', background: '#dc2626', border: 'none', borderRadius: '6px', cursor: 'pointer', color: '#fff' }}
                    >
                        <Edit3 size={16} />
                    </button>
                    <button
                        onClick={() => openDeleteModal(row)}
                        style={{ padding: '8px', background: '#fff', border: '1px solid #fee2e2', borderRadius: '6px', cursor: 'pointer', color: '#ef4444' }}
                    >
                        <Trash2 size={16} />
                    </button>
                </div>
            )
        }
    ]);

    // Fetch classes from the API
    const fetchClasses = () => {
        const headers = {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            'token': localStorage.getItem('token'),
        };

        API.get('/portal/getClasses', { headers })
            .then((response) => {
                if (response.data.response_code === 1000) {
                    const fetchedClasses = response.data.data;
                    setClasses(fetchedClasses);
                    const formsFromAPI = Array.from(
                        new Set(fetchedClasses.map(c => c.tingkatan_moeis?.toUpperCase().trim()))
                    ).filter(Boolean);
                    const missing = fetchedClasses.filter(
                        c => !c.tingkatan_moeis || !c.class_moeis_format
                    );
                    setIncompleteClasses(missing);

                    setUniqueForms(formsFromAPI);
                } else {
                    toast.error(`${response.data.message}`, { autoClose: 5000 });
                }
            })
            .catch(() => {
                toast.error("Error fetching classes", { autoClose: 5000 });
            });
    };
    const openGuruKelasModal = (classRow) => {
        setGuruKelasClass(classRow);
        setGuruKelasOption(null); // reset selection
        setIsGuruKelasModalOpen(true);
    };

    const closeGuruKelasModal = () => {
        setIsGuruKelasModalOpen(false);
        setGuruKelasClass(null);
        setGuruKelasOption(null);
    };
    const handleSetGuruKelas = async () => {
        if (!guruKelasOption) {
            toast.error("Please select a teacher", { autoClose: 3000 });
            return;
        }
        setGuruKelasLoading(true);
        try {
            const headers = { 'token': localStorage.getItem('token') };
            const payload = {
                class_id: guruKelasClass.class_id,
                teacher_uuid: guruKelasOption.value   // << pass the UUID here
            };
            const res = await API.post('/portal/setGuruKelas', payload, { headers });
            if (res.data.response_code === 1000) {
                toast.success("Guru Kelas set!", { autoClose: 3000 });
                closeGuruKelasModal();
                fetchClasses();
            } else {
                toast.error(res.data.message, { autoClose: 3000 });
            }
        } catch (e) {
            toast.error("Server error", { autoClose: 3000 });
        } finally {
            setGuruKelasLoading(false);
        }
    };

    const handleUnsetGuruKelas = async (classRow) => {
        setGuruKelasLoading(true);
        try {
            const headers = { 'token': localStorage.getItem('token') };
            const payload = { class_id: classRow.class_id };
            const res = await API.post('/portal/unsetGuruKelas', payload, { headers });
            if (res.data.response_code === 1000) {
                toast.success("Guru Kelas removed", { autoClose: 3000 });
                fetchClasses();
            } else {
                toast.error(res.data.message, { autoClose: 3000 });
            }
        } catch (e) {
            toast.error("Server error", { autoClose: 3000 });
        } finally {
            setGuruKelasLoading(false);
        }
    };

    // Fetch all teachers from the API
    const fetchTeachers = () => {
        const headers = {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            'token': localStorage.getItem('token'),
        };

        API.get('/portal/getTeachers', { headers })
            .then((response) => {
                if (response.data.response_code === 1000) {

                    const teacherOptions = response.data.data.map((teacher) => ({
                        label: teacher.full_name,
                        value: teacher.teacher_uuid,
                    }));

                    setTeachers(teacherOptions);
                } else {
                    toast.error(`${response.data.message}`, { autoClose: 5000 });
                }
            })
            .catch(() => {
                toast.error("Error fetching teachers", { autoClose: 5000 });
            });
    };

    useEffect(() => {
        fetchClasses();
        fetchTeachers();
    }, []);

    // Open the modal for editing a class
    const openEditModal = (classData) => {
        setSelectedClass(classData);
        setUpdatedClassName(classData.class_name);
        setSelectedTeachers(classData.teachers.map((teacher) => ({
            label: teacher.teacher_name,
            value: teacher.teacher_uuid,
        })));
        setAllTeacherEnabled(classData.all_teacher_enabled ?? 0);
        // Set session
        const sessionOption = sessionOptions.find(opt => opt.value === classData.session);
        setEditSession(sessionOption || null);
        setEditTingkatan(classData.tingkatan_moeis || '');
        setEditClassMoeis(classData.class_moeis_format || '');
        setIsEditModalOpen(true);
    };

    const closeEditModal = () => {
        setSelectedClass(null);
        setIsEditModalOpen(false);
    };
    const openAddModal = () => {
        setNewClassName('');
        setSelectedTeachers([]);
        setIsAddModalOpen(true);
    };

    const closeAddModal = () => {
        setIsAddModalOpen(false);
    };
    const openDeleteModal = (classData) => {
        setSelectedClass(classData);
        setIsDeleteModalOpen(true);
    };

    const closeDeleteModal = () => {
        setSelectedClass(null);
        setIsDeleteModalOpen(false);
    };
    const handleAddClass = () => {
        if (!newClassName) {
            toast.error("Class name cannot be empty", { autoClose: 5000 });
            return;
        }
        if (selectedSession === null) {
            toast.error("Please select a session (morning/afternoon)", { autoClose: 5000 });
            return;
        }
        const headers = {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            'token': localStorage.getItem('token'),
        };
        API.post('/portal/addClass', {
            class_name: newClassName,
            form: selectedForm.value,
            session: selectedSession.value,
            tingkatan_moeis: newTingkatan || null,
            class_moeis: newClassMoeis || null,
        }, { headers })
            .then((response) => {
                if (response.data.response_code === 1000) {
                    toast.success("Class added successfully", { autoClose: 5000 });
                    closeAddModal();
                    fetchClasses();

                } else {
                    toast.error(`${response.data.message}`, { autoClose: 5000 });
                }
            })
            .catch(() => {
                toast.error("Error adding class", { autoClose: 5000 });
            });
    };
    const handleDeleteClass = () => {
        const headers = {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            'token': localStorage.getItem('token'),
        };

        API.post('/portal/deleteClass', {
            class_id: selectedClass.class_id,
        }, { headers })
            .then((response) => {
                if (response.data.response_code === 1000) {
                    toast.success("Class deleted successfully", { autoClose: 5000 });
                    closeDeleteModal();
                    fetchClasses();
                } else {
                    toast.error(`${response.data.message}`, { autoClose: 5000 });
                }
            })
            .catch(() => {
                toast.error("Error deleting class", { autoClose: 5000 });
            });
    };
    const handleSaveChanges = () => {
        if (!updatedClassName) {
            toast.error("Class name cannot be empty", { autoClose: 5000 });
            return;
        }
        if (!editSession) {
            toast.error("Please select a session (morning/afternoon)", { autoClose: 5000 });
            return;
        }
        const headers = {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            'token': localStorage.getItem('token'),
        };

        // Map selected teachers to their UUIDs
        const teacherUUIDs = selectedTeachers.map((teacher) => teacher.value);
        // Send the updated list of teachers to the backend
        API.post('/portal/updateTeachersForClass', {
            class_id: selectedClass.class_id,
            class_name: updatedClassName,
            teacher_uuids: teacherUUIDs,
            session: editSession.value,
            tingkatan_moeis: editTingkatan || null,
            class_moeis: editClassMoeis || null,
            all_teacher_enabled: allTeacherEnabled
        }, { headers })
            .then((response) => {
                if (response.data.response_code === 1000) {
                    toast.success("Class updated successfully", { autoClose: 5000 });
                    closeEditModal();
                    fetchClasses(); // Refresh the classes list
                } else {
                    toast.error(`${response.data.message}`, { autoClose: 5000 });
                }
            })
            .catch(() => {
                toast.error("Error updating class", { autoClose: 5000 });
            });
    };
    const handleExecuteBulkAction = async () => {
        setIsProcessingBulk(true);
        const headers = { 'token': localStorage.getItem('token') };

        // 1. Separate students into Move vs Register
        const studentsToMove = [];
        const studentsToRegister = [];

        bulkData.forEach(d => {
            const lookupKey = d.moeis_name.trim().toUpperCase();
            const isFound = rawCheckResults.foundMap?.[lookupKey];

            if (isFound) {
                // Copy the backend's existing student info (student_uuid, current class, etc)
                studentsToMove.push({
                    moeis_name: isFound.moeis_name,
                    student_uuid: isFound.student_uuid,
                    old_class_id: isFound.class_id,
                    old_class_name: isFound.class_name,
                    new_class_id: d.class_id,         // the target class_id
                    new_class_name: d.new_class_name  // the target class_name
                });
            } else {
                studentsToRegister.push({
                    first_name: d.moeis_name,
                    moeis_name: d.moeis_name,
                    class_id: d.class_id,
                    new_class_name: d.new_class_name
                });
            }
        });

        try {
            // 2. Register New Students if any
            if (studentsToRegister.length > 0) {
                const regRes = await API.post(
                    "/student/registerStudentByAdminPortal",
                    { students: studentsToRegister },
                    { headers }
                );
                if (regRes.data.response_code !== 1000) {
                    toast.error(`Registration failed: ${regRes.data.message}`);
                    setIsProcessingBulk(false);
                    return;
                }
            }

            // 3. Move Existing Students if any
            if (studentsToMove.length > 0) {
                const moveRes = await API.post(
                    '/student/bulkMoveStudentsByMoeis',
                    { students: studentsToMove },
                    { headers }
                );
                if (moveRes.data.response_code === 1000) {
                    setBulkResults(moveRes.data.data);
                } else {
                    toast.error(`Promotion failed: ${moveRes.data.message}`);
                }
            }

            toast.success(`Success: ${studentsToRegister.length} Registered, ${studentsToMove.length} Promoted`);
            fetchClasses();
            // Keep results open or close modal
            if (studentsToMove.length === 0) closeBulkModal();

        } catch (error) {
            toast.error(error);
            console.error(error);
        } finally {
            setIsProcessingBulk(false);
        }
    };

    return (
        <Fragment>

            <button className="btn btn-primary btn-sm" onClick={() => setIsBulkModalOpen(true)}>
                Bulk Class Reassignment
            </button>
            <Modal isOpen={isBulkModalOpen} toggle={closeBulkModal} size="lg">
                <ModalHeader toggle={closeBulkModal}>Batch Class Update (Paste)</ModalHeader>
                <ModalBody>
                    {!bulkResults ? (
                        <>
                            <Alert color="info" className="d-flex align-items-center">
                                <div>
                                    <strong>Instructions:</strong> Copy from sheet and paste the list here <br />
                                    Required: <code>Student Name [Tab/Comma] Class Name</code>
                                </div>
                            </Alert>

                            <textarea
                                className="form-control mb-3"
                                rows="8"
                                placeholder="Example:&#10;AHMAD BIN ALI, 1 AMANAH"
                                value={rawPasteData}
                                onChange={handleRawPasteChange}
                                style={{ fontFamily: 'monospace', fontSize: '13px', border: '2px solid #dee2e6' }}
                            />

                            {bulkData.length > 0 && (
                                <div className="mt-3">
                                    <h6 className="fw-bold d-flex justify-content-between align-items-center">
                                        Preview & Validation ({bulkData.length} rows)
                                        {isCheckingNames && <span className="spinner-border spinner-border-sm text-primary"></span>}
                                    </h6>
                                    <div style={{ maxHeight: '350px', overflowY: 'auto', borderRadius: '8px', border: '1px solid #eee' }}>
                                        <Table size="sm" hover striped className="mb-0">
                                            <thead className="bg-light sticky-top" style={{ zIndex: 1 }}>
                                                <tr>
                                                    <th>Student (MOEIS Name)</th>
                                                    <th>Current Class</th>
                                                    <th>Target Class</th>
                                                    <th className="text-center">Status</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {bulkData.map((d, i) => {
                                                    const lookupKey = d.moeis_name.trim().toUpperCase();
                                                    const isFound = rawCheckResults.foundMap?.[lookupKey];
                                                    const isNotFound = rawCheckResults.notFoundSet?.has(lookupKey);

                                                    return (
                                                        <tr key={i}>
                                                            <td className={isNotFound ? "text-danger fw-bold" : ""}>
                                                                {d.moeis_name}
                                                            </td>
                                                            <td>
                                                                {isFound ? (
                                                                    <>
                                                                        <span className="fw-bold">{isFound.class_name}</span>
                                                                        <br />
                                                                        <span style={{ fontSize: 11, color: "#888" }}>{isFound.class_id}</span>
                                                                    </>
                                                                ) : (
                                                                    <span className="text-muted">-</span>
                                                                )}
                                                            </td>
                                                            <td className={!d.class_id ? "text-danger fw-bold" : ""}>
                                                                {d.new_class_name || "Missing"}
                                                            </td>
                                                            <td className="text-center">
                                                                <div className="d-flex flex-wrap justify-content-center gap-1">
                                                                    {d.class_id ? (
                                                                        <Tag color="blue">Class OK</Tag>
                                                                    ) : (
                                                                        <Tag color="volcano">Wrong Class</Tag>
                                                                    )}
                                                                    {isCheckingNames ? (
                                                                        <Tag color="processing">Checking...</Tag>
                                                                    ) : (
                                                                        isFound ? (
                                                                            <Tag color="green">Student OK</Tag>
                                                                        ) : (
                                                                            <Tag color="red">Wrong Name / New Student</Tag>
                                                                        )
                                                                    )}
                                                                </div>
                                                            </td>
                                                        </tr>
                                                    );
                                                })}
                                            </tbody>

                                        </Table>
                                    </div>
                                </div>
                            )}
                        </>
                    ) : (
                        /* ... Results View Code ... */
                        <div className="text-center p-3">
                            {/* Result counts and failure list as previously defined */}
                        </div>
                    )}
                </ModalBody>
                <ModalFooter>
                    {!bulkResults ? (
                        <div className="d-flex justify-content-between w-100">
                            <Button color="link" className="text-danger" onClick={() => { setRawPasteData(''); setBulkData([]); setRawCheckResults({}); }}>
                                Clear All
                            </Button>
                            <div>
                                <Button color="secondary" onClick={closeBulkModal} className="me-2">Cancel</Button>
                                <Button
                                    color="success"
                                    onClick={handleExecuteBulkAction} // Changed from handleExecuteBulkMove
                                    disabled={
                                        bulkData.length === 0 ||
                                        isProcessingBulk ||
                                        isCheckingNames ||
                                        !bulkData.every(d => d.class_id) // Now ONLY requires the class to be correct
                                    }
                                >
                                    {isProcessingBulk ? "Processing..." : `Process ${bulkData.length} Students`}
                                </Button>
                            </div>
                        </div>
                    ) : (
                        <Button color="primary" onClick={closeBulkModal}>Done</Button>
                    )}
                </ModalFooter>
            </Modal>
            {/* Info Guide */}
            <div className="mb-4">
                {/* Toggle Button for Mobile */}
                <button
                    className="btn btn-sm btn-outline-secondary d-lg-none w-100"
                    onClick={() => setInfoOpen(!infoOpen)}
                >
                    {infoOpen ? "Sembunyi Panduan" : "Tunjuk Panduan"}
                </button>

                {/* Collapsible Content */}
                <Collapse isOpen={infoOpen} className="d-lg-block mt-3">
                    <div
                        className="p-4 border rounded bg-white shadow-sm"
                        style={{ fontSize: "15px", lineHeight: "1.6" }}
                    >
                        <h6 className="fw-bold mb-3 text-dark">Panduan</h6>
                        <ul className="mb-2 ps-3 text-secondary">
                            <li>
                                <strong>Tingkatan MOEIS</strong> – Mesti sama dengan rekod rasmi MOEIS.
                            </li>
                            <li>
                                <strong>Format Kelas MOEIS</strong> – Gunakan format yang tepat
                                (cth. <i>TINGKATAN 1 AMANAH</i>).
                            </li>
                            <li style={{ fontSize: "16px", lineHeight: "1.8" }}>
                                <span
                                    className="badge bg-danger me-2"
                                    style={{ fontSize: "15px", padding: "6px 12px" }}
                                >
                                    Belum Rekod Muka
                                </span>
                                Murid yang <strong>belum merekod wajah</strong> akan{" "}
                                <strong>secara automatik ditandakan sebagai Tidak Hadir ke dalam MOEIS</strong>{" "}
                                dengan sebab mengikut tetapan sekolah (cth. <i>Malas ke Sekolah</i>).
                            </li>
                        </ul>
                        <p className="mt-2 text-muted" style={{ fontSize: "14px", fontWeight: 500 }}>
                            <strong>Tip:</strong> Pastikan Tingkatan & Format Kelas diisi dengan betul
                            untuk elak ralat semakan MOEIS.
                        </p>
                    </div>
                </Collapse>
            </div>

            <div className="container-fluid">
                <div className="mb-3 d-flex flex-wrap gap-2">
                    {/* "All" pill */}
                    <button
                        className={`btn btn-sm ${formFilter === null ? "btn-dark" : "btn-outline-dark"}`}
                        onClick={() => setFormFilter(null)}
                    >
                        All
                    </button>

                    {/* Dynamic pills from API */}
                    {uniqueForms.map((form) => (
                        <button
                            key={form}
                            className={`btn btn-sm ${formFilter === form ? "btn-dark" : "btn-outline-dark"}`}
                            onClick={() => setFormFilter(form)}
                        >
                            {form}
                        </button>
                    ))}
                </div>
                {incompleteClasses.length > 0 && (
                    <div
                        className="d-flex flex-column"
                        role="alert"
                        style={{
                            borderRadius: "12px",
                            fontWeight: "600",
                            fontSize: "15px",
                            padding: "16px 20px",
                            marginBottom: "20px",
                            backgroundColor: "#ffc107",
                            color: "#212529",
                        }}
                    >
                        <div className="d-flex align-items-center justify-content-between">
                            <div>
                                <span
                                    style={{
                                        display: "inline-flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        width: "60px",
                                        height: "60px",
                                        borderRadius: "50%",
                                        background: "#fff",
                                        color: "#000", // yellow number
                                        fontWeight: "900",
                                        margin: "0 12px",
                                        fontSize: "28px",
                                        boxShadow: "0 4px 12px rgba(0,0,0,0.2)",
                                    }}
                                >
                                    {incompleteClasses.length}
                                </span>

                                <strong>Action required:</strong>{" "}
                                {incompleteClasses.length > 1 ? "Classes are" : "Class is"} missing{" "}
                                <strong>MOEIS info</strong>.{" "}
                                <span style={{ fontWeight: "500" }}>
                                    Update now to ensure smooth MOEIS integration.
                                </span>
                            </div>

                            {/* Action button */}
                            <button
                                className="btn btn-dark btn-sm"
                                onClick={() => {
                                    const currentClass = incompleteClasses[currentIncompleteIndex];
                                    if (currentClass) {
                                        openEditModal(currentClass);
                                    }
                                }}
                            >
                                Fix Now
                            </button>
                        </div>
                    </div>

                )}


                <div className="row">
                    <div className="col-12">
                        <div className="card rounded-25">
                            <div className="card-header rounded-25 text-red">
                                <h5>Classes</h5>
                                <button
                                    className="btn btn-primary float-end"
                                    onClick={openAddModal}
                                >
                                    Add Class
                                </button>
                            </div>
                            <div className="card-body">
                                <div className="table-responsive">
                                    <DataTable
                                        columns={columns}
                                        data={filteredClasses}
                                        striped={true}
                                        center={false}
                                        responsive
                                        persistTableHead

                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {selectedClass && (
                <Modal isOpen={isEditModalOpen} toggle={closeEditModal}>
                    <ModalHeader toggle={closeEditModal}>
                        Edit Class Details
                    </ModalHeader>
                    <ModalBody>
                        <div className="form-group">
                            <label>Class Name</label>
                            <input
                                type="text"
                                className="form-control"
                                value={updatedClassName}
                                onChange={(e) => setUpdatedClassName(e.target.value)}
                            />
                        </div>
                        <div className="form-check mt-3">
                            <input
                                type="checkbox"
                                className="form-check-input"
                                id="allTeacherEnabled"
                                checked={allTeacherEnabled === 1}
                                onChange={(e) => setAllTeacherEnabled(e.target.checked ? 1 : 0)}
                            />
                            <label className="form-check-label fw-bold" htmlFor="allTeacherEnabled">
                                Enable for ALL Teachers
                            </label>
                        </div>

                        <div className="form-group">
                            <label>Assign Teachers</label>
                            {isEditModalOpen && (
                                <Select
                                    isMulti
                                    options={teachers}
                                    value={selectedTeachers}
                                    onChange={setSelectedTeachers}
                                    isDisabled={allTeacherEnabled === 1}
                                />

                            )}
                            {allTeacherEnabled === 1 && (
                                <div className="text-muted mt-1" style={{ fontSize: '12px' }}>
                                    All teachers are automatically enabled for this class.
                                </div>
                            )}

                        </div>
                        <div className="form-group" style={{ marginTop: 16 }}>
                            <label>Select Session</label>
                            <Select
                                options={sessionOptions}
                                value={editSession}
                                onChange={setEditSession}
                                placeholder="Select session"
                            />
                        </div>
                        <div className="form-group" style={{ marginTop: 16 }}>
                            <label>Tingkatan (MOEIS)</label>
                            <input
                                type="text"
                                className="form-control"
                                value={editTingkatan}
                                onChange={(e) => setEditTingkatan(e.target.value)}
                            />
                        </div>
                        <div className="form-group" style={{ marginTop: 16 }}>
                            <label>MOEIS Class Format</label>
                            <input
                                type="text"
                                className="form-control"
                                value={editClassMoeis}
                                onChange={(e) => setEditClassMoeis(e.target.value)}
                            />
                        </div>
                    </ModalBody>
                    <ModalFooter>
                        <Button color="primary" onClick={handleSaveChanges}>
                            Save Changes
                        </Button>
                        <Button color="secondary" onClick={closeEditModal}>
                            Cancel
                        </Button>
                    </ModalFooter>
                </Modal>
            )}
            <Modal isOpen={isAddModalOpen} toggle={closeAddModal}>
                <ModalHeader toggle={closeAddModal}>
                    Add New Class
                </ModalHeader>
                <ModalBody>
                    <div className="form-group">
                        <label>Class Name</label>
                        <input
                            type="text"
                            className="form-control"
                            value={newClassName}
                            onChange={(e) => setNewClassName(e.target.value)}
                        />
                    </div>
                    <div className="form-group">
                        <label>Select Standard/Form</label>
                        <Select
                            options={forms}
                            value={selectedForm}
                            onChange={setSelectedForm}
                        />
                    </div>
                    <div className="form-group">
                        <label>Tingkatan (MOEIS)</label>
                        <input
                            type="text"
                            className="form-control"
                            value={newTingkatan}
                            onChange={(e) => setNewTingkatan(e.target.value)}
                        />
                    </div>
                    <div className="form-group">
                        <label>MOEIS Class Format</label>
                        <input
                            type="text"
                            className="form-control"
                            value={newClassMoeis}
                            onChange={(e) => setNewClassMoeis(e.target.value)}
                        />
                    </div>
                    <div className="form-group">
                        <label>Select Session</label>
                        <Select
                            options={sessionOptions}
                            value={selectedSession}
                            onChange={setSelectedSession}
                            placeholder="Select session"
                        />
                    </div>

                </ModalBody>
                <ModalFooter>
                    <Button color="btn btn-dark" onClick={handleAddClass}>
                        Add Class
                    </Button>
                    <Button color="btn btn-primary" onClick={closeAddModal}>
                        Cancel
                    </Button>
                </ModalFooter>
            </Modal>
            <Modal isOpen={isDeleteModalOpen} toggle={closeDeleteModal}>
                <ModalHeader toggle={closeDeleteModal}>
                    Confirm Delete
                </ModalHeader>
                <ModalBody>
                    Are you sure you want to delete the class: <strong>{selectedClass?.class_name}</strong>?
                </ModalBody>
                <ModalFooter>
                    <Button color="btn btn-dark" onClick={handleDeleteClass}>
                        Yes, Delete
                    </Button>
                    <Button color="btn btn-primary" onClick={closeDeleteModal}>
                        Cancel
                    </Button>
                </ModalFooter>
            </Modal>
            <Modal isOpen={isGuruKelasModalOpen} toggle={closeGuruKelasModal}>
                <ModalHeader toggle={closeGuruKelasModal}>
                    Set Guru Kelas for <span className="fw-bold">{guruKelasClass?.class_name}</span>
                </ModalHeader>
                <ModalBody>
                    <div className="mb-3">
                        <label>Select Guru Kelas</label>
                        <Select
                            options={teachers}
                            value={guruKelasOption}
                            onChange={setGuruKelasOption}
                            placeholder="Choose teacher"
                        />
                    </div>
                </ModalBody>
                <ModalFooter>
                    <Button
                        color="primary"
                        onClick={handleSetGuruKelas}
                        disabled={guruKelasLoading}
                    >
                        {guruKelasLoading ? "Saving..." : "Set Guru Kelas"}
                    </Button>
                    <Button
                        color="secondary"
                        onClick={closeGuruKelasModal}
                        disabled={guruKelasLoading}
                    >
                        Cancel
                    </Button>
                </ModalFooter>
            </Modal>
        </Fragment>
    );
};

export default ClassesPage;
